<template>
  <div class="home">
    <common>
      <template slot="content">
        <div class="login" v-if="!login">
            <img src="../assets/images/login1.png"  srcset="../assets/images/login1@2x.png 2x,../assets/images/login1@3x.png 3x"  alt="" class="login-btn"  @click="changeAccount">
        </div>
        <div class="login-box" v-if="login">
          <div class="login-title">
            <span class="left">您好，{{userInfo.nick}}</span>
            <span class="right" @click="changeAccount">切换账号</span>
          </div>
          <div>
            <el-form ref="phonecode" :model="form" :rules="rules">
              <el-form-item prop="code" label="激活码:">
                <el-input placeholder="" clearable v-model="form.code" class="input-box">
                </el-input>
              </el-form-item>
              <img src="../assets/images/activate.png" srcset="../assets/images/activate@2x.png 2x,../assets/images/activate@3x.png 3x"  alt="" class="jihuo-btn" @click="handleActive('phonecode')">
            </el-form>
          </div>
        </div>
        <div class="use-box">
          <p class="use-title">使用须知</p>
          <div class="use-content">
            <div class="content-title">1.登录腾讯账号后，输入激活码即可激活VIP会员卡；</div>
            <div class="content-title">2.手机号登录并领取后，需要完成与微信或QQ号绑定后才可使用腾讯视频VIP；
              <div class="binding" @click="toAddress"></div>
            </div>
            <div class="content-title">3.请在激活有效期内使用，过期作废，不予退款；</div>
            <div class="content-title">4.此激活码严禁倒卖、转让、不可兑换现金，请妥善保管，遗失泄漏不补充。</div>
<!--            <div class="content-title">5.如有疑问，请咨询QQ在线客服：800085092</div>-->
          </div>
        </div>
<!--        <div class="newtv-toast" v-if="toast" @click="toastClose">-->
<!--          <div class="newtv-toast-text">-->
<!--            <template v-if="status==='success'">-->
<!--              <h3 class="success">激活成功！</h3>-->
<!--            </template>-->
<!--            <template v-else>-->
<!--              <h3>激活失败！</h3>-->
<!--              <p>请重试</p>-->
<!--            </template>-->
<!--          </div>-->
<!--        </div>-->
      </template>
    </common>
  </div>
</template>

<script>
  import {Toast} from 'mint-ui'
  import common from './common'

  export default {
    name: 'home',
    components: {common},
    data () {
      return {
        activeDialogVisible: false,
        login: false,
        form: {
          code: '',
        },
        rules: {
          code: [{
            required: true,
            message: '请输入兑换码',
            trigger: 'blur'
          }]
        },
        userInfo: {},
        queryCode: '',
        requestJson: {},
        toast: false,
        status: '',
        toastTime: null
      }
    },
    created () {
      this.init();
    },
    methods: {
      init () {
        this.queryCode = this.$route.query;

        if(this.queryCode.code){
          if(sessionStorage.getItem("code")){
            this.requestJson = {
              userType: sessionStorage.getItem("userType"),
              userId: sessionStorage.getItem("userId"),
              appId: sessionStorage.getItem("appId"),
              signature:  sessionStorage.getItem("signature"),
              nick: sessionStorage.getItem("nick"),
              pic: sessionStorage.getItem("pic")
            };
            this.userInfo.nick = sessionStorage.getItem("nick");
            this.login = true;
          }else{
            sessionStorage.setItem("code", this.queryCode.code);
            this.getInfo();
          }
        }

        //如果是手机登录
        if (sessionStorage.getItem('mobile')) {
          this.login = true
          this.userInfo.nick = sessionStorage.getItem('mobile').substring(0,3)+"****"+sessionStorage.getItem('mobile').substring(7,11)
          this.requestJson = {
            userType: 6,
            userId: sessionStorage.getItem('mobile')
          }
        }
        // todo 2020.12.18 自动兑换二维码需求。 增加 自动填充兑换码参数 cardSecret
        const cardSecret =  this.$route.query.cardSecret;
        if (cardSecret) {
          localStorage.setItem('cardSecret',cardSecret);
        }

        if (localStorage.getItem('cardSecret')){
          this.form.code = localStorage.getItem('cardSecret');
        }
        // end

      },
      changeAccount: function () {
        sessionStorage.clear();
        this.$router.replace('/login')
      },
      toastClose: function(){
        clearTimeout(this.toastTime);
        this.toast = false;
      },
      //微信 || QQ登录 获取用户信息
      /**
       * {
            "response": {
                "nick": "biu biu biu",
                "openId": "755BC97E5FFF770BE0AF5AF5C50FA084",
                "appId": "101483052",
                "sign": "8a6ea8c749a2687a366806674840a37c",
                "pic": "http://thirdqq.qlogo.cn/g?b=sdk&k=qev3RjlUiaiarLgPYMtv41Fg&s=140&t=1558936427",
                "accessToken": "mM1wXidyGfSN0D1ZHUW7jg24hM71X_sv88UqFF00IFSJFKa-4D-lrlIdLxnXF-cp",
                "type": 0
            },
            "errorCode": 0,
            "errorMessage": "success"
        }
       */
      getInfo () {
        var that = this
        this.newAjax({
          url: '/goldenpheasant/service/txAuth/getResource',
          data: {
            code: sessionStorage.getItem("code")
          },
          success: function (data) {
            if (data.errorCode == 0) {
              that.login = true
              that.userInfo = data.response;
              that.requestJson = {
                userType: data.response.type,
                userId: data.response.openId,
                appId: data.response.appId,
                signature: data.response.sign,
                nick: data.response.nick,
                pic: data.response.pic
              }
              sessionStorage.setItem("userType",data.response.type);
              sessionStorage.setItem("userId",data.response.openId);
              sessionStorage.setItem("appId",data.response.appId);
              sessionStorage.setItem("signature",data.response.sign);
              sessionStorage.setItem("nick",data.response.nick);
              sessionStorage.setItem("pic",data.response.pic);
            } else {
              that.login = false
              Toast({
                message: '登录失败，请重新登录！',
                position: 'center',
                duration: 8000
              })
            }
          },
          error: function (error) {
            Toast({
              message: '登录失败，请重新登录！',
              position: 'center',
              duration: 8000
            })
          }
        })
      },

      handleActive: function (formName) {
        let that = this
        this.requestJson.cardSecret = this.form.code;
        // clearTimeout(this.toastTime);
        this.$refs[formName].validate((valid) => {
          if (valid) {
            //获取token
            this.newAjax({
              url: '/goldenpheasant/service/getToken',
              success: function (data) {
                if (data.errorCode == 0) {
                  that.active(that.requestJson, data.errorMessage);
                  // todo 2020.12.18 兑换成功后删除cardSecret本地存储
                  localStorage.setItem('cardSecret', '');
                  // end
                } else {
                  Toast({
                    message: data.errorMessage,
                    position: 'center',
                    duration: 8000
                  })
                  // that.toast = true;
                  // // that.status = 'error';
                  // that.toastTime = setTimeout(function(){
                  //   that.toast = false;
                  // },8000)
                }
              },
              error: function (error) {
                Toast({
                  message: error.errorMessage,
                  position: 'center',
                  duration: 8000
                })
                // that.toast = true;
                // that.status = 'error';
                // that.toastTime = setTimeout(function(){
                //   that.toast = false;
                // },8000)
              }
            })
          } else {

          }
        })


      },
      //激活
      active (json, token) {
        let that = this;
        this.newAjax({
          url: '/goldenpheasant/service/txTopUp/vipRecharge',
          method: 'POST',
          header: {
            'SignToken': token,
            'Content-Type': 'application/json; charset=utf-8'
          },
          data: JSON.stringify(json),
          success: function (data) {
            if (data.errorCode === 0) {
              Toast({
                message: data.errorMessage == 'success' ? '兑换成功' : 'data.errorMessage',
                position: 'center',
                duration: 8000
              })
              // that.toast = true;
              //  that.status = 'success';
              // that.toastTime = setTimeout(function(){
              //   that.toast = false;
              // },8000)
            } else {
              Toast({
                message: data.errorMessage,
                position: 'center',
                duration: 8000
              })
              // that.toast = true;
              // that.status = 'error';
              // that.toastTime = setTimeout(function(){
              //   that.toast = false;
              // },8000)
            }
          },
          error: function (error) {
            Toast({
              message: error.errorMessage,
              position: 'center',
              duration: 8000
            })
            // that.toast = true;
            // that.status = 'error';
            // that.toastTime = setTimeout(function(){
            //   that.toast = false;
            // },8000)
          }
        })
      },

      //绑定地址
      toAddress () {
        window.location.href = 'https://film.qq.com/act/phone-reward/index.html?buss_id=product.charge&buss_type=charge&ptag=partner'
      }
    }
  }
</script>
<style scoped lang="less">
  .login {
    background: url("../assets/images/login-bg.png") no-repeat;
    background-size: contain;
    width: 15.6rem;
    height: 9.552rem;
    margin: auto;
    position: relative;
  }

  .login-btn {
    width: 6.624rem;
    height: 2.016rem;
    position: absolute;
    top: 6.336rem;
    left: 4.704rem;
  }

  .login-box {
    background: url("../assets/images/loginbg.png") no-repeat;
    background-size: contain;
    width: 15.6rem;
    height: 9.552rem;
    margin: auto;
    padding: 0 1.68rem;
    position: relative;
  }

  .login-title {
    padding-top: 1.152rem;
    padding-bottom: 1.92rem;
  }

  .left {
    float: left;
    font-size: 0.576rem;
    color: #80531F;
  }

  .right {
    float: right;
    color: #80531F;
    font-size: 0.72rem;
  }

  .input-box {
    height: 1.536rem;
    line-height: 1.536rem;
    width: 9.12rem;
  }

  .jihuo-btn {
    width: 6.624rem;
    height: 2.016rem;
    position: absolute;
    top: 6.336rem;
    left: 4.704rem;
  }

  .use-box {
    margin-top: 1.104rem;
    margin-bottom: 4rem;
  }

  .use-title {
    font-size: 0.96rem;
    color: #FFE6B9;
    margin-bottom: 0.576rem;
  }

  .use-content {
    margin: 0 1.25rem;
    text-align: left;
  }

  .use-content .content-title {
    font-size: 0.672rem;
    color: #FFE6B9;
    line-height: 0.96rem;
    margin: 0.144rem;
  }

  .binding {
    display: inline-block;
    background: url("../assets/images/bindAddress.png") no-repeat;
    background-size: contain;
    margin-top: 0.096rem;
    width: 3.36rem;
    height: 0.96rem;
  }

  /deep/ .el-form-item__label {
    font-size: 0.72rem;
    color: #80531F;
  }

  /deep/ .el-input__inner {
    background-color: #FFFFFF;
    border: none;
    line-height: 24px;
  }

  .el-dialog {
    background-color: #000000;
    z-index: 9999;

  }

  .mint-toast-text {
    font-size: 32px;
  }

  .newtv-toast{
    width: 100%;
    height: 100%;
    z-index: 4;
    position: absolute;
    left: 0 ;
    top: 0;
    background-color: transparent;
  }
  .newtv-toast-text {
    position: fixed;
    display: block;
    background-color: rgba(0,0,0,.8);
    width: 224/375*18rem;
    height: 130/375*18rem;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    color: #FFFFFF;
    h3 {
      margin-top: 27/375*18rem;
      font-size: 42/375*18rem;
      width: 100%;
      text-align: right;
      margin-bottom: 10/375*18rem;
      &.success{
        margin: 0 auto;
        line-height: 130/375*18rem;
      }
    }
    p {
      font-size: 18/375*18rem;
    }
  }

  /* 如果设备像素大于等于2，则用2倍图 */
  @media screen and (-webkit-min-device-pixel-ratio: 2), screen and (min--moz-device-pixel-ratio: 2) {
    .login {
      background: url("../assets/images/login-bg@2x.png") no-repeat;
      background-size: contain;
    }
    .binding {
      background: url("../assets/images/bindAddress@2x.png") no-repeat;
      background-size: contain;
    }
  }
  @media screen and (-webkit-min-device-pixel-ratio: 3), screen and (min--moz-device-pixel-ratio: 3) {
    .login {
      background: url("../assets/images/login-bg@3x.png") no-repeat;
      background-size: contain;
    }
    .binding {
      background: url("../assets/images/bindAddress@3x.png") no-repeat;
      background-size: contain;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/home.vue